import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { selectUser } from 'app/store/userSlice';
import jwtDecode from 'jwt-decode';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import { userContext } from '../layout1/Layout1';

function UserMenu(props) {
  const user = useSelector(selectUser);

  const [userMenu, setUserMenu] = useState(null);
  const [displayName, setDisplayName] = useState();
  const [userDetail , setUserDetail] = useContext(userContext)
  const [profileImageUrl, setProfileImageUrl] = useState();
  const [role, setRole] = useState();

  const userMenuClick = (event) => {
    setUserMenu(event.currentTarget);
  };

  const userMenuClose = () => {
    setUserMenu(null);
  };
  const usersImg = async () => {
    const token = jwtDecode(localStorage.getItem('token'));
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${token.email}`;
    const result = await OAuthService.getList(url);
    const users = result?.data;
    if (users.profileImage) {
      const response = await OAuthService.getDownload(`${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/image/download/${users.profileImage}`);
      const imgURL = URL.createObjectURL(response.data)
      setProfileImageUrl(imgURL)
    }else{
      setProfileImageUrl('')
    }
  }
  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = jwtDecode(localStorage.getItem('token'));
      setDisplayName(token.name);
      const arg = 'ROLE_';
      let roles = token?.scope.filter(value => {
        return value.startsWith(arg);
      });
      const names = async() => {
        const roleUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}`;
        const roleName =  await Promise.all(roles?.map(async (role) => {
          const name = await OAuthService.getEditData(roleUrl,role);
          return name?.data?.displayName;          
        }));
        setRole(roleName.toString());
        return roleName;
      }

      names();
       usersImg();
    }
  }, [localStorage.getItem('token')])

  return (
    <>
      <Button
        className="min-h-30 min-w-30 px-0 md:px-16 py-0 md:py-6"
        onClick={userMenuClick}
        color="inherit"
      >
        <div className="hidden md:flex flex-col mx-4 items-end">
          <Typography component="span" className="font-semibold flex">
            {displayName}
          </Typography>
          <Typography className="text-11 font-medium capitalize" color="text.secondary">
            {role}
          </Typography>
        </div>

        {profileImageUrl ? (
          <Avatar className="md:mx-4" alt="user photo" sx={{ width: 30, height: 30 }} src={profileImageUrl} />
        ) : (
          <Avatar className="md:mx-4" sx={{ width: 30, height: 30 }}>{displayName && displayName.charAt(0)}</Avatar>
        )}
      </Button>

      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
       
        {displayName && (
          <>
            <MenuItem
              component={NavLink}
              to="/sign-out"
              onClick={() => {
                
                userMenuClose();
              }}
            >
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon>heroicons-outline:logout</FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary="Sign out" />
            </MenuItem>
            <MenuItem component={Link} to="/profile" onClick={userMenuClose} role="button">
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon>heroicons-outline:user-circle</FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary="My Profile" />
            </MenuItem>
            <MenuItem component={Link} to="/changePassword" onClick={userMenuClose} role="button">
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon>heroicons-outline:key</FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary="Change Password" />
            </MenuItem>
          </>
        )}

        {/* </>
        )} */}
      </Popover>
    </>
  );
}

export default UserMenu;
